import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SaveIcon from '@mui/icons-material/Save';
import useMessage from '../../util/useMessage';
import { useForm } from 'react-hook-form';
import SubmitButton from '../../ui/SubmitButton';
import EnumSelect from '../../ui/EnumSelect';
import InputText from '../../ui/InputText';
import TenantBatchOperationservice from '../../service/MasterServices/TenantBatchOperationService';
import BatchOperationservice from '../../service/MasterServices/BatchOperationService';
import masterTenantservice from '../../service/MasterServices/MasterTenantService';
import ComplexSelect from '../../ui/ComplexSelect ';
import SwitchInput from '../../ui/SwitchInput';
import OperationType from '../../enum/OperationType';
import TimeInput from '../../ui/TimeInput';
import ComplexAutocomplete from '../../ui/ComplexAutocomplete';
import { useSelector } from 'react-redux';
import MailGruplariservice from '../../service/GeneralServices/MailGruplariService';

const TenantBatchOperationCrudDialog = ({ open, onClose, data, crudTip, title }) => {


    const { t } = useTranslation();
    const showMessage = useMessage();
    const [crudtitle, SetCrudtitle] = useState("");

    const [OperationIdList, setOperationIdList] = useState([]);
    const [TenantIdList, setTenantIdList] = useState([]);
    const [intervalTipi, setIntervalTipi] = useState();
    const { user } = useSelector(state => state.auth);

    const daysOfWeeklist = [
        { key: 'Pazartesi', value: 1 },  // Monday
        { key: 'Salı', value: 2 },       // Tuesday
        { key: 'Çarşamba', value: 3 },   // Wednesday
        { key: 'Perşembe', value: 4 },   // Thursday
        { key: 'Cuma', value: 5 },       // Friday
        { key: 'Cumartesi', value: 6 },  // Saturday
        { key: 'Pazar', value: 7 }       // Sunday
    ];

    const daysList = Array.from({ length: 30 }, (_, i) => ({ key: i + 1, value: i + 1 }));


    const inputObject = {
        tenantId: data?.tenantId,
        operationId: data?.operationId,
        aktif: data?.aktif ?? true,
        operationType: data?.operationType,
        interval: data?.interval,
        specificTime: data?.specificTime,
        toEmail: data?.toEmail,
        ccEmail: data?.ccEmail,
        bccEmail: data?.bccEmail,
        param1: data?.param1,
        param2: data?.param2,
    }

    console.log(data?.specificTime);

    const [MailGruplariList, setMailGruplariList] = useState([]);

    const getMailGruplariList = async (TenantId) => {
        try {
            let result;
            if (TenantId) {
                result = await TenantBatchOperationservice.getTenantMailGroup({ id: TenantId });
            } else {
                result = await MailGruplariservice.get();
            }

            if (result?.isSuccess) {
                setMailGruplariList(result.resultObject);
            } else {
                console.error('Failed to fetch MailGruplari list:', result?.message || 'Unknown error');
            }
        } catch (error) {
            console.error('An error occurred while fetching MailGruplari list:', error);
        }
    };



    const { handleSubmit, register, control, reset, formState: { errors }, setValue } = useForm({
        defaultValues: {
            ...inputObject
        }
    });

    useEffect(() => {
        if (OperationIdList.length > 0 && data?.operationId) {
            setValue("operationId", OperationIdList.find(r => r.operationId === data?.operationId));
        }
    }, [OperationIdList, data, setValue]);

    const loadSource = async () => {
        var OperationIdRes = await BatchOperationservice.get();

        if (OperationIdRes && OperationIdRes.isSuccess) {
            setOperationIdList(OperationIdRes.resultObject);
        }

        if (data && data?.tenantId != null) {
            await getMailGruplariList(data?.tenantId);
        }

        if (!user.isMaster) {
            await getMailGruplariList();
        }


        var TenantIdRes = await masterTenantservice.get();
        if (TenantIdRes && TenantIdRes.isSuccess) {
            setTenantIdList(TenantIdRes.resultObject);
        }

        setIntervalTipi(data?.operationType);



    }

    useEffect(() => {
        if (open) {
            loadSource();
            reset({
                ...inputObject
            });



            setLoading(false);
            setStatusUpdated(false);
            if (crudTip == "Create") {
                SetCrudtitle(t(title) + " " + t("button.add"))
            } else {
                SetCrudtitle(t(title) + " " + t("button.update"))
            }
        }
    }, [open, reset]);

    const [loading, setLoading] = useState(false);

    const [statusUpdated, setStatusUpdated] = useState(false);

    const Create = async (input) => {

        const { resultObject } = await TenantBatchOperationservice.create(
            {
                tenantId: input.tenantId,
                operationId: input?.operationId?.operationId,
                aktif: input.aktif,
                operationType: input?.operationType,
                daysOfWeek: input?.daysOfWeek?.join(','),
                daysOfMonth: input?.daysOfMonth?.join(','),
                interval: input?.interval,
                specificTime: input?.specificTime,
                toEmail: input?.toEmail,
                ccEmail: input?.ccEmail,
                bccEmail: input?.bccEmail,
                isMaster: user.isMaster,
                param1: input?.param1,
                param2: input?.param2
            }
        );

        return resultObject;
    }
    const Update = async (input) => {
        // Ensure daysOfWeek is an array before calling join
        const daysOfWeek = Array.isArray(input.daysOfWeek) ? input.daysOfWeek.join(',') : '';
        const daysOfMonth = Array.isArray(input.daysOfMonth) ? input.daysOfMonth.join(',') : '';

        const { resultObject } = await TenantBatchOperationservice.fullupdate(
            {
                id: data?.id,
                tenantId: input.tenantId,
                operationId: input?.operationId?.operationId,
                aktif: input.aktif,
                operationType: input?.operationType,
                daysOfWeek: daysOfWeek,
                daysOfMonth: daysOfMonth,
                interval: input?.interval,
                specificTime: input?.specificTime,
                toEmail: input?.toEmail,
                ccEmail: input?.ccEmail,
                bccEmail: input?.bccEmail,
                isMaster: user.isMaster,
                param1: input?.param1,
                param2: input?.param2
            }
        );

        return resultObject;
    }

    const OperationTypeHandler = (value) => {
        setIntervalTipi(value);
        setValue("interval", 1);
        setValue("daysOfWeek", []);
        setValue("daysOfMonth", []);
    }


    const onSubmit = async (input) => {
        if (loading)
            return false;

        try {
            setLoading(true);

            let status = false;
            if (crudTip == "Create") {
                status = await Create(input);
            } else {

                status = await Update(input);
            }

            setLoading(false);

            if (status) {
                setStatusUpdated(true);
                showMessage(t('message.created'));
            } else {
                showMessage(t('message.updateFailed'));
            }

            return status;

        } catch (error) {
            setLoading(false);

            console.log(error);
        }


    }

    const GetIntervalTipi = () => {
        return (
          <>
            <Grid item xs={12}>
              <Box display="flex" gap={2} alignItems="center">
                <InputText
                  name="interval"
                  type="number"
                  label={t("label.interval")}
                  error={errors?.interval}
                  control={control}
                  rules={{ required: t("validation.required") }}
                />
                <TimeInput name="specificTime" label={t("label.specificTime")} control={control} />
              </Box>
            </Grid>

            {intervalTipi == 3 && (
              <Grid item xs={12}>
                <ComplexSelect
                  name="daysOfWeek"
                  label={t("label.daysOfWeek")}
                  data={daysOfWeeklist}
                  control={control}
                  error={errors.daysOfWeek}
                  valueKey={"value"}
                  displayKey={"key"}
                  multiple={true}
                />
              </Grid>
            )}

            {intervalTipi == 4 && (
              <Grid item xs={12}>
                <ComplexSelect
                  name="daysOfMonth"
                  label={t("label.daysOfMonth")}
                  data={daysList}
                  control={control}
                  error={errors.daysOfMonth}
                  valueKey={"value"}
                  displayKey={"key"}
                  multiple={true}
                />
              </Grid>
            )}

            {intervalTipi == 6 && (
              <Grid item xs={12}>
                <Box display="flex" gap={2} alignItems="center">
                  <InputText name="param1" type="text" label={t("label.param1")} control={control} />
                  <InputText name="param2" type="text" label={t("label.param2")} control={control} />
                </Box>
              </Grid>
            )}
          </>
        );
    }



    const InsertForm = () => {
        return (
            <Grid container spacing={1} alignItems="center">

                <Grid item xs={12}>
                    <ComplexAutocomplete
                        name="operationId"
                        label={t("label.operationId")}
                        data={OperationIdList}
                        control={control}
                        error={errors.operationId}
                        valueKey={"operationId"}
                        displayKey={["operationId", "operationName"]}
                        rules={{ required: t('validation.required') }}
                    />
                </Grid>

                {user.isMaster && <Grid item xs={12}>
                    <ComplexSelect
                        name="tenantId"
                        label={t('label.tenantName')}
                        data={TenantIdList}
                        control={control}
                        error={errors.tenantId}
                        valueKey={"id"}
                        displayKey={"name"}
                        rules={{ required: t('validation.required') }}
                        onChange={(tenantId) => getMailGruplariList(tenantId)}
                    />
                </Grid>
                }

                <Grid item xs={12}>
                    <SwitchInput
                        name="aktif"
                        label={t("label.aktif")}
                        control={control}
                        setValue={setValue}
                        rules={{ required: t('validation.required') }}
                        errorMessage={errors.aktif?.message}
                    />
                </Grid>

                <Grid item xs={12}>
                    <EnumSelect
                        name="operationType"
                        control={control}
                        label={t('label.operationType')}
                        rules={{ required: t('validation.required') }}
                        StatusEnum={OperationType}
                        onChange={OperationTypeHandler}
                    />
                </Grid>
                {GetIntervalTipi()}
                <Grid item xs={6}>
                    <ComplexSelect
                        name="toEmail"
                        label={t("label.toEmail")}
                        data={MailGruplariList}
                        control={control}
                        error={errors.toEmail}
                        valueKey="id"
                        displayKey={["mail"]}
                    />
                </Grid>
                <Grid item xs={6}>
                    <ComplexSelect
                        name="ccEmail"
                        label={t("label.ccEmail")}
                        data={MailGruplariList}
                        control={control}
                        error={errors.ccEmail}
                        valueKey="id"
                        displayKey={["mail"]}
                    />
                </Grid>
                <Grid item xs={6}>
                    <ComplexSelect
                        name="bccEmail"
                        label={t("label.bccEmail")}
                        data={MailGruplariList}
                        control={control}
                        error={errors.bccEmail}
                        valueKey="id"
                        displayKey={["mail"]}
                    />
                </Grid>
            </Grid>
        );

    }

    const UpdateForm = () => {

        return (
            <Grid container spacing={1} alignItems="center">


                <Grid item xs={12}>
                    <ComplexAutocomplete
                        name="operationId"
                        label={t("label.operationId")}
                        data={OperationIdList}
                        control={control}
                        error={errors.operationId}
                        valueKey={"operationId"}
                        displayKey={["operationId", "operationName"]}
                        rules={{ required: t('validation.required') }}
                    />
                </Grid>

                {user.isMaster && <Grid item xs={12}>
                    <ComplexSelect
                        name="tenantId"
                        label={t('label.tenantId')}
                        data={TenantIdList}
                        control={control}
                        error={errors.tenantId}
                        valueKey={"id"}
                        displayKey={"name"}
                        rules={{ required: t('validation.required') }}
                    />
                </Grid>
                }

                <Grid item xs={12}>
                    <SwitchInput
                        name="aktif"
                        label={t("label.aktif")}
                        control={control}
                        setValue={setValue}
                        rules={{ required: t('validation.required') }}
                        errorMessage={errors.aktif?.message}
                    />
                </Grid>

                <Grid item xs={12}>
                    <EnumSelect
                        name="operationType"
                        control={control}
                        label={t('label.operationType')}
                        rules={{ required: t('validation.required') }}
                        StatusEnum={OperationType}
                        onChange={OperationTypeHandler}
                    />
                </Grid>
                {GetIntervalTipi()}

                <Grid item xs={6}>
                    <ComplexSelect
                        name="toEmail"
                        label={t("label.toEmail")}
                        data={MailGruplariList}
                        control={control}
                        error={errors.toEmail}
                        valueKey="id"
                        displayKey={["mail"]}
                    />
                </Grid>
                <Grid item xs={6}>
                    <ComplexSelect
                        name="ccEmail"
                        label={t("label.ccEmail")}
                        data={MailGruplariList}
                        control={control}
                        error={errors.ccEmail}
                        valueKey="id"
                        displayKey={["mail"]}
                    />
                </Grid>
                <Grid item xs={6}>
                    <ComplexSelect
                        name="bccEmail"
                        label={t("label.bccEmail")}
                        data={MailGruplariList}
                        control={control}
                        error={errors.bccEmail}
                        valueKey="id"
                        displayKey={["mail"]}
                    />
                </Grid>
            </Grid>
        );
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth={"xl"}
            scroll="paper"
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    {crudtitle}
                </DialogTitle>

                <DialogContent dividers={true} style={{ display: 'flex', gap: '16px' }}>
                    {data ? UpdateForm() : InsertForm()}
                </DialogContent>
                <DialogActions>
                    {statusUpdated ? (
                        <Button onClick={onClose} color="primary">
                            {t('button.done')}
                        </Button>
                    ) : (
                        <React.Fragment>
                            <Button onClick={onClose} color="primary" disabled={loading}>
                                {t('button.cancel')}
                            </Button>
                            <SubmitButton loading={loading} startIcon={<SaveIcon />}>
                                {t('button.save')}
                            </SubmitButton>
                        </React.Fragment>
                    )}
                </DialogActions>

            </form>

        </Dialog>
    );

};


export default React.memo(TenantBatchOperationCrudDialog);


